



















































































































































































































































































































































import {
  CarpCategoryCarpCategoryDTO,
  CarpCategoryCarpSubCategoryDTO,
  CarpCategoryListSubCategoryRequest,
  CarpCategoryManagerService,
  CarpsaleManagementCarpsaleService,
  CarpsaleManagementCategoryItemRequest,
  CarpsaleManagementItemDTO,
  CarpsaleManagementListItemRequest,
  StoreHistoryManagementListOrderRequest,
} from "@/common/api";
import QCalendar from "@/common/qCalendar.vue";
import QErrors from "@/common/qErrors.vue";
import qNotify from "@/common/qNotify";
import QPaginate from "@/common/qPaginate.vue";
import QSearch from "@/common/qSearch.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import ExportItemsComponent from "@/components/admin/carpsale/common/exportItemsComponent.vue";
import GenerateCertComponent from "@/components/admin/carpsale/common/generateCertComponent.vue";
import ImportItemsComponent from "@/components/admin/carpsale/common/importItemsComponent.vue";
import QMultiSelect from "@/components/common/qMultiSelect.vue";
import QSelect from "@/components/common/qSelect.vue";
import PaginateModel from "@/model/paginate";
import _ from "lodash";
import { Component, Vue, Watch } from "vue-property-decorator";

const initFilter: CarpsaleManagementListItemRequest = {
  sales: [],
  categoryIds: [],
  subCategoryIds: [],
  statuses: [],
  saleCode: "",
  nameOrCode: "",
  company: "",
  keyword: "",
  sort: "userCreated",
  direction: CarpsaleManagementListItemRequest.direction.DESC,
  perPage: 30,
  page: 1,
};

@Component({
  name: "CarpsaleListComponent",
  components: {
    QErrors,
    QSelect,
    ImportItemsComponent,
    ExportItemsComponent,
    GenerateCertComponent,
    QCalendar,
    QMultiSelect,
    QSearch,
    QPaginate,
    QTableHeader,
  },
})
export default class CarpsaleListComponent extends Vue {

  get isSelectAll() {
    let check = true;
    for (const item of this.items) {
      if (!this.selectedItems.includes(item.id)) {
        check = false;
      }
    }

    return check;
  }
  public errors = [];
  public items: CarpsaleManagementItemDTO[] = [];
  public categories: CarpCategoryCarpCategoryDTO[] = [];
  public subCategories: CarpCategoryCarpSubCategoryDTO[] = [];

  public sort = "desc";

  public editingSort = false;
  public sortCategoryId = null;
  public sortSubCategoryId = null;
  public isLoadingSubCategories = false;
  public sortErrors = {};
  public originSortItems: any[] = [];
  public sortItems: CarpsaleManagementItemDTO[] = [];
  public sortSubCategories: CarpCategoryCarpSubCategoryDTO[] = [];
  public selectedItems = [];

  public sales = [
    {
      id: "1",
      name: "セール対象商品",
    },
    {
      id: "0",
      name: "セール対象外商品",
    },
  ];

  public types = [
    {
      id: "consumer",
      name: "一般会員のみ",
    },
    {
      id: "business",
      name: "業者会員のみ",
    },
    {
      id: "both",
      name: "すべて",
    },
  ];

  public statuses = [
    {
      id: "release",
      name: "有効",
    },
    {
      id: "no_release",
      name: "無効",
    },
    {
      id: "hold",
      name: "保留",
    },
  ];

  public filter = _.clone(initFilter);

  public sortFilter: CarpsaleManagementCategoryItemRequest = {
    categoryId: null,
    subCategoryId: null,
  };

  public pagination = new PaginateModel({
    page: 1,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });

  public isLoading = false;

  public isRequiredSubCategory = false;

  public changeDirection() {
    if (
      this.filter.direction === CarpsaleManagementListItemRequest.direction.DESC
    ) {
      this.filter.direction = CarpsaleManagementListItemRequest.direction.ASC;
    } else {
      this.filter.direction = CarpsaleManagementListItemRequest.direction.DESC;
    }
    this.items = [];
    this.search();
  }

  @Watch("filter.categoryIds")
  public changeCategory() {
    this.getSubCategories(this.filter.categoryIds);
  }

  public scroll(event) {
    const listElm = event.target;
    if (
      !this.isLoading &&
      Math.ceil(listElm.scrollTop + listElm.clientHeight) >=
        listElm.scrollHeight &&
      this.pagination.page < this.pagination.pageCount
    ) {
      this.isLoading = true;
      this.filter.page += 1;
      this.getItems(this.filter).then((items) => {
        this.items = [...this.items, ...items];
        // eslint-disable-next-line unicorn/no-array-reduce
      });
      this.isLoading = false;
    }
  }

  public async mounted() {
    await this.getCategories();
    await this.getSubCategories();
    this.getDataFromUrl();
    this.search();
  }

  public search() {
    this.filter.page = 1;
    this.$router
      .push({
        query: {
          sort: this.filter.sort,
          direction: this.filter.direction,
          sales: this.filter.sales,
          categoryIds: this.filter.categoryIds,
          subCategoryIds: this.filter.subCategoryIds,
          statuses: this.filter.statuses,
          saleCode: this.filter.saleCode,
          nameOrCode: this.filter.nameOrCode,
          company: this.filter.company,
        } as any,
      })
      .catch(() => {
        //
      });

    this.getItems(this.filter).then((items) => {
      this.items = items;

      // eslint-disable-next-line unicorn/no-array-reduce
    });
  }

  public async getItems(query = {}) {
    const result = await CarpsaleManagementCarpsaleService.adminCarpsale(query);
    this.pagination = new PaginateModel({
      page: result.data.paginator.currentPage,
      pageCount: result.data.paginator.lastPages,
      start: result.data.paginator.currentPage,
      end: result.data.paginator.lastPages,
      count: result.data.paginator.total,
    });

    this.filter.page = result.data.paginator.currentPage;

    return result.data.items;
  }

  public async getCategories() {
    const result = await CarpCategoryManagerService.adminCarpCategory({});
    this.categories = result.data.carp_categories;
  }

  public async getSubCategories(category_ids: string[] = []) {
    const result = await CarpCategoryManagerService.adminCarpSubCategory({
      categories: category_ids,
      disabledLoadinng: true,
    } as CarpCategoryListSubCategoryRequest);
    this.subCategories = result.data.carp_sub_categories;
  }

  public resetSearch() {
    this.filter = _.clone(initFilter);
    this.search();
  }

  public sortStore(sort): void {
    if (this.filter.sort !== sort) {
      this.filter.sort = sort;
      this.filter.direction =
        StoreHistoryManagementListOrderRequest.direction.DESC;
    } else {
      this.filter.direction =
        this.filter.direction ===
        StoreHistoryManagementListOrderRequest.direction.DESC
          ? StoreHistoryManagementListOrderRequest.direction.ASC
          : StoreHistoryManagementListOrderRequest.direction.DESC;
    }

    this.search();
  }

  public showSortPopup() {
    this.editingSort = true;
  }

  public changeSortCategory() {
    this.sortSubCategoryId = null;
    this.sortSubCategories = [];
    this.getSortSubCategories();
  }

  public changeSortSubCategory() {
    if (this.sortSubCategoryId == "null") {
      this.sortSubCategoryId = null;
    }
  }

  public async getSortSubCategories() {
    if (this.sortCategoryId) {
      this.isLoadingSubCategories = true;
      const result = await CarpCategoryManagerService.adminCarpSubCategory({
        categories: [this.sortCategoryId],
        disabledLoadinng: true,
      } as CarpCategoryListSubCategoryRequest);
      this.sortSubCategories = result.data.carp_sub_categories;
      this.isRequiredSubCategory = this.sortSubCategories.length > 0;
      this.isLoadingSubCategories = false;
    }
  }

  public showSortItems() {
    this.sortFilter = {
      categoryId: this.sortCategoryId,
      subCategoryId: this.sortSubCategoryId,
    };
    this.getSortItems(this.sortFilter).then((items) => {
      this.sortItems = items;
      this.originSortItems = JSON.parse(JSON.stringify(items));
    });
  }

  public resetSort() {
    this.sortItems = [];
    this.originSortItems = [];
    this.sortCategoryId = null;
    this.sortSubCategoryId = null;
  }

  public confirmCancel() {
    if (_.isEqual(this.originSortItems, this.sortItems)) {
      this.cancelEditSort();
    } else {
      this.$modal.showCancel({
        text: this.$t("common.message.cancel_confirm"),
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.cancelEditSort();
        },
      });
    }
  }

  public cancelEditSort() {
    this.editingSort = false;
    this.sortErrors = {};
    this.resetSort();
  }

  public async getSortItems(query) {
    this.sortErrors = {};
    let result;
    try {
      result = await CarpsaleManagementCarpsaleService.adminCarpsaleListSort(
        query,
      );
    } catch (error) {
      result = error;
    }

    if (result.status == "success") {
      return result.data.items;
    } else if (result.status == "400") {
      this.sortErrors = result.body.errors;
    } else {
      qNotify.error({
        text: result.body.message,
      });
    }
  }

  public async syncItems() {
    this.sortErrors = {};
    let result;
    const data = [];

    for (const value of this.sortItems) {
      data.push({ id: value.id, sort_order: value.sort_order });
    }

    try {
      result = await CarpsaleManagementCarpsaleService.adminCarpsaleSync({
        items: data,
      });
      if (result.status == "success") {
        qNotify.success({
          text: this.$t("common.message.created"),
        });
        await this.showSortItems();
      }
    } catch (error) {
      result = error;
      qNotify.error({
        text: result.body.message,
      });

      if (result.status == "400") {
        this.sortErrors = result.body.errors;
      } else {
        qNotify.error({
          text: result.body.message,
        });
      }
    }
  }

  public selectAll() {
    if (this.isSelectAll) {
      for (const item of this.items) {
        if (this.selectedItems.includes(item.id)) {
          const index = this.selectedItems.indexOf(item.id);
          this.selectedItems.splice(index, 1);
        }
      }
    } else {
      for (const item of this.items) {
        if (!this.selectedItems.includes(item.id)) {
          this.selectedItems.push(item.id);
        }
      }
    }
  }

  private getDataFromUrl() {
    const currentQuery = this.$router.currentRoute.query;

    if (currentQuery.sales) {
      const sales = currentQuery.sales;
      if (typeof sales === "string") {
        this.filter.sales = [currentQuery.sales as string];
      } else if (typeof sales === "object") {
        this.filter.sales = currentQuery.sales as string[];
      }
    }

    if (currentQuery.categoryIds) {
      const categoryIds = currentQuery.categoryIds;
      if (typeof categoryIds === "string") {
        this.filter.categoryIds = [currentQuery.categoryIds as string];
      } else if (typeof categoryIds === "object") {
        this.filter.categoryIds = currentQuery.categoryIds as string[];
      }
    }

    if (currentQuery.subCategoryIds) {
      const subCategoryIds = currentQuery.subCategoryIds;
      if (typeof subCategoryIds === "string") {
        this.filter.subCategoryIds = [currentQuery.subCategoryIds as string];
      } else if (typeof subCategoryIds === "object") {
        this.filter.subCategoryIds = currentQuery.subCategoryIds as string[];
      }
    }

    if (currentQuery.statuses) {
      const statuses = currentQuery.statuses;
      if (typeof statuses === "string") {
        this.filter.statuses = [currentQuery.statuses as string];
      } else if (typeof statuses === "object") {
        this.filter.statuses = currentQuery.statuses as string[];
      }
    }

    if (currentQuery.direction) {
      this.filter.direction = String(
        currentQuery.direction,
      ) as CarpsaleManagementListItemRequest.direction;
    }

    if (currentQuery.sort) {
      this.filter.sort = String(currentQuery.sort);
    }

    if (currentQuery.saleCode) {
      this.filter.saleCode = String(currentQuery.saleCode);
    }

    if (currentQuery.nameOrCode) {
      this.filter.nameOrCode = String(currentQuery.nameOrCode);
    }

    if (currentQuery.company) {
      this.filter.company = String(currentQuery.company);
    }

    if (currentQuery.perPage) {
      this.filter.perPage = Number(currentQuery.perPage);
    }
  }
}
